export const environment = {
    production: false,
    isLocalhost: false,
};
